<template>
  <PaginatedCrud
    ref="list"
    as-table
    :scrollable="false"
    immediate
    :fetch-fn="fetcRecordingFn"
    :columns="tableColumns"
    :selectable="false"
    :show-no-data="false"
  >
    <template v-slot:add-controls>
      <MRow>
        <MCol :size="12" class="flex justify-end">
          <MButton variant="default" class="mr-2 mb-2" @click="refresh">
            <MIcon name="sync"></MIcon> {{ $tc('refresh') }}
          </MButton>
        </MCol>
      </MRow>
    </template>
    <template v-slot:form>
      <span />
    </template>
    <template v-slot:createdAt="{ item }">
      <td class="text-ellipsis">
        {{ item.createdAt | datetime }}
      </td>
    </template>
    <template v-slot:status="{ item }">
      <td class="text-ellipsis">
        {{ item.status ? $tc(item.status) : '---' }}
      </td>
    </template>
    <template v-slot:actions="{ item }">
      <td>
        <MButton
          v-if="item.status === 'failed' || item.status === 'not_converted'"
          variant="default"
          @click="handleConvertToM4v(item)"
        >
          {{ $tc('convert_to_m4v') }}
        </MButton>
        <FlotoDownloadLink
          v-else-if="item.status === 'converted'"
          :file-name="item.m4vFileName"
          :url="`download/rdp/downloadRecording/${resource.name}/${item.m4vFileName}`"
        >
          <template v-slot:trigger="{ downloading }">
            <MButton :loading="downloading">
              <MTooltip>
                <template v-slot:trigger>
                  {{ $tc('download') }}
                </template>
                {{ $tc('file') }} {{ $tc('size') }}: {{ item.m4vFileSize }}
              </MTooltip>
            </MButton>
          </template>
        </FlotoDownloadLink>
        <!-- <MButton v-else-if="item.status === 'converted'">
          <MTooltip>
            <template v-slot:trigger>
              <a
                :href="`/api/download/rdp/downloadRecording/${resource.name}/${item.m4vFileName}?mid=${accessToken}`"
                target="_blank"
              >
                {{ $tc('download') }}
              </a>
            </template>
            {{ $tc('file') }} {{ $tc('size') }}: {{ item.m4vFileSize }}
          </MTooltip>
        </MButton> -->
        <span v-else>---</span>
        <MButton v-if="item.playUrl" class="mx-2">
          <MTooltip>
            <template v-slot:trigger>
              <a :href="item.playUrl" target="_blank">
                {{ $tc('play_url') }}
              </a>
            </template>
            {{ $tc('play_url') }}
          </MTooltip>
        </MButton>
      </td>
    </template>
    <template v-slot="slotData">
      <slot v-bind="slotData"></slot>
    </template>
  </PaginatedCrud>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import Uniq from 'lodash/uniq'
import { getRDPRecordingApi, convetToM4vApi } from '@modules/asset/asset-api'
import PaginatedCrud from '@components/paginated-crud'

export default {
  name: 'RDPRecordingTab',
  components: { PaginatedCrud },
  props: {
    resource: { type: Object, required: true },
    fetchFn: { type: Function, default: undefined },
  },

  data() {
    return {
      tableColumns: [
        { name: `${this.$tc('file')} ${this.$tc('name')}`, key: 'fileName' },
        { name: `${this.$tc('status')}`, key: 'status' },
        { name: `${this.$tc('created_time')}`, key: 'createdAt' },
        {
          name: `${this.$tc('action')}`,
          key: 'actions',
          width: '220px',
          align: 'left',
        },
      ],
      actionSticked: [],
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    fetcRecordingFn() {
      if (this.fetchFn) {
        return this.fetchFn()
      }
      return getRDPRecordingApi(this.resource.name)
    },
    refresh() {
      this.$refs.list.refreshCurrentPage()
    },
    stickActionFor(item) {
      this.actionSticked = Uniq([...this.actionSticked, item.id])
    },
    unStickActionFor(item) {
      this.actionSticked = this.actionSticked.filter((id) => id !== item.id)
    },
    handleConvertToM4v(item) {
      convetToM4vApi(this.resource.name, item.fileName).then(() => {
        this.refresh()
      })
    },
  },
}
</script>
